"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NearestPickupPointsSkeleton = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _DeliveryBoxSkeleton = require("./DeliveryBoxSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
const TitleSkeleton = (0, _mui.styled)(_mui.Skeleton)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(2)
    };
});
const NearestPickupPointsSkeleton = ()=>{
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        "data-testid": getTestId(_models.TestId.NearestPickupPointsSkeleton),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleSkeleton, {
                animation: "wave",
                variant: "text",
                width: 80,
                height: 32
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DeliveryBoxSkeleton.DeliveryBoxSkeleton, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TitleSkeleton, {
                animation: "wave",
                variant: "text",
                width: 150,
                height: 32
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DeliveryBoxSkeleton.DeliveryBoxSkeleton, {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_DeliveryBoxSkeleton.DeliveryBoxSkeleton, {})
        ]
    });
};
exports.NearestPickupPointsSkeleton = NearestPickupPointsSkeleton;
